import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Service2 from '../../components/Service2'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import { Helmet } from 'react-helmet';
import coursesBanner from '../../images/banners/courses.webp'


const ServicePage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>Courses | Dar-ul-Quran Academy UK</title>
                <meta name="description" content="Explore our online Quran courses for all ages: Basic Qaida, Tajweed, Hifz, and more. Flexible schedules and expert tutors for UK families." />
                <link rel="canonical" href="https://www.thedarulquran.com/service" />
            </Helmet>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'} backgroundImage={coursesBanner} hideText={true}/> 
            <Service2 serviceClass={'s2'}/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServicePage;
